<div [ngClass]="['step-progress', statusStyle]" ngbTooltip="{{statusLabel}}" role="img" [attr.aria-label]="statusLabel">
  <i [ngClass]="statusIcon" aria-hidden="true"></i>
</div>